module.exports = __webpack_public_path__ + "802a8e0f40887832d33ba427a79fa28c.svg";